import { Component, Input } from "@angular/core"

@Component({
  selector: 'flow-accordion-container',
  templateUrl: './flow-accordion-container.component.html',
  styleUrl: './flow-accordion-container.component.scss',
  standalone: false,
})
export class FlowAccordionContainerComponent {
  /* This component works same way as ag-tree-v2 where you need to insert ag-accordion in this components parent component*/

  @Input() width: string = ""
  constructor() {}
}
